import { newApiInstance } from 'functions/request';

export const getRetailersGroupsTitles = () => newApiInstance.get(`/groups`);
